module.exports = __webpack_public_path__ + "img/user.7a21cbe9.svg";